import "src/css/widgets/widgets.css";

import { connect } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useState, useEffect, useRef } from 'react';
import MonitorWSService from 'src/services/monitorwsservice';
import { useTranslation } from 'react-i18next';
import AgentCard from "./agentcard";
import { abbreviate } from 'src/components/utils/utils';
import WidgetSettings from "src/components/widgets/widgetSettings"
import { removeWidget } from "src/redux/supervisorSlice";
import { selectionTypes } from "src/components/utils/consts";
import WidgetTools from "src/components/widgets/widgetTools";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Col, Row, Form } from "react-bootstrap";
import { Switch, SelectBox } from "devextreme-react";

const fistList = [
    { id: "", name: "none" },
    { id: "Free", name: "registered" },
    { id: "Paused", name: "paused" },
    { id: "Wrapup", name: "wrapup" },
    { id: "Unregistered", name: "unregistered" },
    { id: "LoggedOut", name: "loggedout" },
    { id: "Talking", name: "talking" }
];

function AgentsPanel(props) {

    const { t } = useTranslation();
    const lastUpdate = useRef(new Date());
    lastUpdate.current.setMinutes(lastUpdate.current.getMinutes() - 1);

    const [agents, setAgents] = useState([]);
    const [allAgents, setAllAgents] = useState([]);
    const [filter, setFilter] = useState(localStorage.getItem("agentsPanelFilter") || "");
    const [showSettings, setShowSettings] = useState(false);
    const [groupId, setGroupId] = useState(-1);
    const [groupName, setGroupName] = useState(localStorage.getItem(`AgentsPanel_groupName_${props.identifier}_user${props.id}`) || t("all2"));
    const [asc, setAsc] = useState(false);
    const [showConfig, setShowConfig] = useState(false);
    const [highlight, setHighlight] = useState(JSON.parse(localStorage.getItem(`AgentsPanel_highlight_${props.identifier}_user${props.id}`) || "false"));
    const [showFirst, setShowFirst] = useState(localStorage.getItem(`AgentsPanel_showfirst_${props.identifier}_user${props.id}`) || "");


    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/agentscards", {}, JSON.stringify({
                    token: props.token,
                }));

                MonitorWSService.stompClient.unsubscribe("agentscards");
            }
            setAgents([]);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (props.connected) {
            let groupId = parseInt(localStorage.getItem(`AgentsPanel_groupId_${props.identifier}_user${props.id}`) || -1);
            setGroupId(groupId)
            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/agentscards/`, updateAgents, { id: "agentscards" });

            MonitorWSService.stompClient.send("/app/subscribe/agentscards", {}, JSON.stringify({
                token: props.token,
                groupId: groupId
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected, asc, props.maxPauseTime, props.maxConversation, props.formOpenWithoutActivity, showFirst, highlight, filter]);

    const updateAgents = (agents) => {
        let lastUpdateDiff = (new Date() - lastUpdate.current);

        if (!document.hidden && lastUpdateDiff > 1000) {

            var data = JSON.parse(agents.body);
            data.forEach(v => {

                if (v.strAcdStatus === "LoggedOut")
                    v.strAcdStatus = v.ext !== null && v.ext.length > 0 ? "Unregistered" : v.strAcdStatus;

                if (v.strAcdStatus === "Wrapup" && v.strStatus === "Talking")
                    v.strAcdStatus = "Free";

                v.pauseAlarm = false;
                v.currentCallAlarm = false;

                let userId = parseInt(v.pin);
                let phoneDiff = 0;
                let then = new Date();
                let now = Date.now();

                then.setSeconds(then.getSeconds() - v.currentCallDuration);

                phoneDiff = (now - then) / 1000;
                if (v.phoneStatusChanged !== null && v.strStatus === "Talking" && !v.dialing && !v.ringing) {

                    if (props.maxConversation > 0 && phoneDiff > props.maxConversation && (!props.excludeAgents || props.excludeAgents.indexOf(userId) === -1)) {
                        v.currentCallAlarm = true;
                    }
                }

                if (v.strAcdStatus === "Paused") {
                    var diff = 0,
                        acdStatusChanged = new Date();

                    acdStatusChanged.setSeconds(acdStatusChanged.getSeconds() - v.timeDiffAcdStatus);
                    diff = Math.floor((now - acdStatusChanged) / 1000);
                    if ((v.pauseExceeded || (props.maxPauseTime > 0 && diff > props.maxPauseTime)) && (!props.excludeAgents || props.excludeAgents.indexOf(userId) === -1)) {
                        v.pauseAlarm = true;
                    }
                }
                v.formOpenAlarm = false;

                if (v.formOpen && v.strStatus !== 'Talking')
                    v.formOpenAlarm = props.formOpenWithoutActivity > 0 && props.formOpenWithoutActivity < v.currentCallDuration && props.excludeAgents.indexOf(data.pin) === -1;

            });

            let filteredAgents = data;

            if (filter !== null && filter !== "")
                filteredAgents = data.filter(x => x.name.toLowerCase().indexOf(filter) > -1);
            if (asc) {
                filteredAgents.sort(sortByACDStatus);
            } else {
                filteredAgents.sort(sortByACDStatusDesc);
            }

            lastUpdate.current = new Date();
            setAgents(filteredAgents);
            setAllAgents(data);
        }
    }

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const setGroup = (groupId, groupName) => {
        setShowSettings(!showSettings);
        setGroupId(groupId);
        setGroupName(groupName);
        localStorage.setItem(`AgentsPanel_groupId_${props.identifier}_user${props.id}`, groupId);
        localStorage.setItem(`AgentsPanel_groupName_${props.identifier}_user${props.id}`, groupName);
        MonitorWSService.stompClient.send("/app/subscribe/agentscards", {}, JSON.stringify({
            token: props.token,
            groupId: groupId
        }));

    };

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }

    const sortByACDStatus = (a, b) => {
        let acdA = a.strAcdStatus;
        let acdB = b.strAcdStatus;
        const phoneA = a.strStatus;
        const phoneB = b.strStatus;
        let indexA = 0;
        let indexB = 0;

        if (a.formOpen)
            acdA = "Wrapup";
        if (b.formOpen)
            acdB = "Wrapup";

        switch (acdA) {
            case "Free":
                indexA = -5;
                break;
            case "Wrapup":
                indexA = -4;
                break;
            case "Paused":
                indexA = -3;
                break;
            case "Unregistered":
                indexA = -2;
                break;
            case "LoggedOut":
                indexA = -1;
                break;
            default:
                indexA = 0;
                break;
        }

        if ((showFirst === acdA || "Talking" !== phoneA) || ("Talking" === phoneA && showFirst === phoneA))
            indexA = -6;

        switch (acdB) {
            case "Free":
                indexB = -5
                break;
            case "Wrapup":
                indexB = -4
                break;
            case "Paused":
                indexB = -3
                break;
            case "Unregistered":
                indexB = -2
                break;
            case "LoggedOut":
                indexB = -1
                break;
            default:
                indexB = 0;
                break;
        }

        if ((showFirst === acdB || "Talking" !== phoneB) || ("Talking" === phoneB && showFirst === phoneB))
            indexB = -6;

        return indexA > indexB ? -1 : 1;

    }

    const sortByACDStatusDesc = (a, b) => {

        let acdA = a.strAcdStatus;
        let acdB = b.strAcdStatus;
        const phoneA = a.strStatus;
        const phoneB = b.strStatus;
        let indexA = 0;
        let indexB = 0;

        if (a.formOpen)
            acdA = "Wrapup";
        if (b.formOpen)
            acdB = "Wrapup";

        switch (acdA) {
            case "Free":
                indexA = -1
                break;
            case "Wrapup":
                indexA = -2
                break;
            case "Paused":
                indexA = -3;
                break;
            case "Unregistered":
                indexA = -4;
                break;
            case "LoggedOut":
                indexA = -5;
                break;
            default:
                indexA = -6;
                break;
        }

        //Always taking agents are shown last
        if ((showFirst === acdA && "Talking" !== phoneA) || ("Talking" === phoneA && showFirst === phoneA))
            indexA = 0;

        switch (acdB) {
            case "Free":
                indexB = -1;
                break;
            case "Wrapup":
                indexB = -2;
                break;
            case "Paused":
                indexB = -3;
                break;
            case "Unregistered":
                indexB = -4;
                break;
            case "LoggedOut":
                indexB = -5;
                break;
            default:
                indexB = -6;
                break;
        }
        //Always taking agents are shown first
        if ((showFirst === acdB && "Talking" !== phoneB) || ("Talking" === phoneB && showFirst === phoneB))
            indexB = 0;

        return indexA > indexB ? -1 : 1;

    }

    const toggleSort = () => {
        setAsc(!asc);
    }

    const toggleConfig = () => {
        setShowConfig(!showConfig);
    }

    const handleShowFirstChange = (value) => {
        setShowFirst(value);
        localStorage.setItem(`AgentsPanel_showfirst_${props.identifier}_user${props.id}`, value);
    }

    const handleHighlight = (value) => {
        setHighlight(value);
        localStorage.setItem(`AgentsPanel_highlight_${props.identifier}_user${props.id}`, value);
    }

    const handleChange = (e) => {
        let filter = e.target.value.toLowerCase();
        setFilter(filter);
        localStorage.setItem("agentsPanelFilter", filter);
    }

    return (

        <div className={"card card-flush overflow-hidden h-lg-20 widget-container"}>
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("address-card")} /> {t("agentspanel")} - {groupName} <span className="badge badge-light-primary fs-base">{agents.length}</span></span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {t("sort")}
                        </Tooltip>}>
                        <button type="button" className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" onClick={toggleSort} >
                            {
                                asc &&
                                <FontAwesomeIcon size="lg" icon={duotone("arrow-up")} />
                            }
                            {
                                !asc &&
                                <FontAwesomeIcon size="lg" icon={duotone("arrow-down")} />
                            }
                        </button>
                    </OverlayTrigger>
                    <button type="button" className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" onClick={toggleConfig} >
                        <FontAwesomeIcon icon={duotone("cogs")} />
                    </button>
                    <WidgetTools  key={`tools_${props.identifier}`}closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>

                </div>
            </div>
            <div className="card-body" style={{ height: "100%", overflow: "auto", padding: "0rem 2.25rem" }}>
                <Row>
                    <Col xxl={showConfig ? 8 : 12} style={{ padding: 0 }}>
                        <div className="agents-panel-list">
                            {
                                agents.map(v => {
                                    v.initials = abbreviate(v.name);
                                    return <AgentCard key={v.pin} agent={v} highlight={highlight}></AgentCard>
                                })
                            }
                        </div>
                    </Col>
                    {
                        showConfig &&
                        <Col xxl={4}>
                            <Row className="mb-1">
                                <Col>
                                    <Form.Control value={filter} type="text" placeholder={t("search")} onChange={handleChange}></Form.Control>
                                </Col>
                            </Row>
                            <Row className="mb-1">
                                <Col>
                                    <Form.Label htmlFor='highlight'>{t("highlight")}</Form.Label>
                                </Col>
                                <Col>
                                    <Switch id='highlight' rtlEnabled={props.rtl} switchedOnText={t("yes")} switchedOffText={t("no")} value={highlight} onValueChange={handleHighlight} />
                                </Col>
                            </Row>
                            <Row className="mb-1" >
                                <Col>
                                    <Form.Label className="showfirst">{t("showfirst")}</Form.Label>
                                </Col>
                                <Col>
                                    <SelectBox
                                        dataSource={fistList.map(x => { return { id: x.id, name: t(x.name) } })}
                                        value={showFirst}
                                        onValueChange={handleShowFirstChange}
                                        valueExpr="id"
                                        displayExpr="name"
                                        searchEnabled={true}
                                        dropDownButtonRender={() => { return (<FontAwesomeIcon icon={duotone("down")} />) }}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    }
                </Row>
            </div>
            <WidgetSettings key={`settings_${props.identifier}`} showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroup={setGroup} groupId={groupId} groupName={groupName} selectionType={selectionTypes.GROUP}></WidgetSettings>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        maxPauseTime: state.parameters.maxPauseTime,
        id: state.supervisor.id,
        rtl: state.parameters.rtl,
        excludeAgents: state.parameters.excludeAgents,
        maxConversation: state.parameters.maxConversation,
        formOpenWithoutActivity: state.parameters.formOpenWithoutActivity
    };
};


export default connect(mapStateToProps, { removeWidget })(AgentsPanel);